import ACTIONS from "../../constants/actions";
import _ from 'lodash';

const dataFromLs = localStorage.getItem('favorites');

const initialState = dataFromLs ? JSON.parse(dataFromLs) : [];

export default function favorites(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.FAVORITES.TOGGLE:
			const actionData = typeof action.data === 'object' ? action.data.slice() : [action.data];
			const intersect = _.intersection(state, actionData);
			const data = _.pullAll([...state, ...actionData], intersect);
			localStorage.setItem('favorites', JSON.stringify(data));
			return data;

		case ACTIONS.FAVORITES.UPDATE:

			break;

		case ACTIONS.FAVORITES.DELETE:

			break;
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/favorites.js